import {
  FaMapMarkerAlt,
  FaRegClock,
  FaStar,
  FaPlane,
  FaUmbrella,
} from "react-icons/fa";
import ExperienceLayout from "./ExperienceLayout";
import imageHero from "../../assets/kilimanjaro.jpg";
import imageDay1 from "../../assets/kili2.jpg";
import imageDay2 from "../../assets/kili2.jpg";
import imageDay3 from "../../assets/beans.jpg";

const hero = {
  kicker: "Kilimanjaro Expeditions",
  title: "Roof of Africa",
  subtitle: "Guided climbs across scenic routes with professional support teams.",
  backgroundImage: imageHero,
  meta: ["Private crews", "Multiple routes", "Acclimatization focused"],
};

const overview =
  "Mount Kilimanjaro is Africa’s highest peak. Our expeditions blend lush forests, alpine deserts, and final snowfields with expert guides and full support teams so you can safely reach Uhuru Peak.";

const highlights = [
  {
    icon: FaMapMarkerAlt,
    title: "Diverse terrain",
    description: "From rainforest to glacier, every route reveals Kilimanjaro’s ecological stages.",
  },
  {
    icon: FaUmbrella,
    title: "Support teams",
    description: "Professional guides, cooks, porters, and medical backup keep the climb smooth.",
  },
  {
    icon: FaStar,
    title: "Sunrise summit",
    description: "Summit just before dawn with panoramic views of Africa below.",
  },
  {
    icon: FaPlane,
    title: "Flexible routes",
    description: "Choose Machame, Lemosho, Rongai, or Marangu depending on pace and views.",
  },
];

const details = [
  {
    icon: FaMapMarkerAlt,
    title: "Location",
    description: "Kilimanjaro National Park, Tanzania—eastern Africa’s crown.",
  },
  {
    icon: FaRegClock,
    title: "Seasons",
    description: "January–March and June–October deliver clear skies and stable weather.",
  },
];

const itinerary = [
  {
    dayLabel: "Day 1 • Mountain Brief",
    title: "Arrival & gear prep",
    image: imageDay1,
    body: "Arrive, meet guides, and prep your gear during the evening briefing in Moshi.",
    activities: "Arrival, briefing, equipment check",
  },
  {
    dayLabel: "Day 2 • Forest Trek",
    title: "Machame Gate start",
    image: imageDay2,
    body: "Enter through rainforest, ascend through moorland, and camp at Machame or Shira stripes.",
    activities: "Trekking, acclimatization hikes",
  },
  {
    dayLabel: "Day 3 • Summit Push",
    title: "Sunrise over Uhuru",
    image: imageDay3,
    body: "Summit from Barafu at dawn, soak in the views, and descend to Mweka for celebration.",
    activities: "Summit, descent, celebration",
  },
];

export default function KilimanjaroExpedition() {
  return (
    <ExperienceLayout
      hero={hero}
      overview={overview}
      highlights={highlights}
      details={details}
      itinerary={itinerary}
    />
  );
}
